import { selectorFamily } from 'recoil';
import { convertDisputeSummaries } from 'functions';
import { DisputeService } from 'services';
import { currentDate, disputeFilter, disputeReasons, disputeSummaries, isAuthenticated, refreshState, userInfo } from 'state';
import { DisputeReason } from 'types';
import { buildDisputeApiFilter } from './disputeFilter';

export const filteredDisputeReasons = selectorFamily<DisputeReason[], string>({
    key: 'filteredDisputeReasons',
    get: (accountId) =>
        async ({ get }) => {
            const reasons = get(disputeReasons);
            const filter = get(disputeFilter);

            if (filter.selectedReasonId == null) {
                const disputes = get(disputeSummaries({ accountId }));
                return reasons.filter(({ disputeReasonId }) => disputes.find(dispute => dispute.disputeReasonId === disputeReasonId));
            }

            get(currentDate);
            get(refreshState('disputeRefresh'));
            get(refreshState(disputeSummaries({ accountId }).key));

            const user = get(userInfo);

            if (!(get(isAuthenticated) && (user.isInternalUser || accountId))) {
                return [];
            }

            const service = new DisputeService();
            const data = await service.getDisputeSummariesByFilter(
                buildDisputeApiFilter(filter, accountId, user, { omitDisputeReasonId: true })
            );
            const disputes = convertDisputeSummaries(data);

            return reasons.filter(({ disputeReasonId }) => disputes.find(dispute => dispute.disputeReasonId === disputeReasonId));
        }
});
